<script>
import appConfig from "@/app.config.json";
import sp from "@/views/pages/project/sp/sale/instruction/index.vue";
import pc from "@/views/pages/project/pc/sale/instruction/index.vue";
import DeviceDetectionMixin from "@/mixins/DeviceDetectionMixin";

export default {
  page: {
    title: "作業指示詳細",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [DeviceDetectionMixin],
  components: {
    sp,
    pc
  },
  computed: {
    dailyReportId() {
      return this.$route.query.daily_report_id != undefined ? this.$route.query.daily_report_id : null
    },
  }
}
</script>

<template>
  <sp v-if="this.detectMobileDevice()"/>
  <pc v-else />
</template>
